export default {
    Metadata: {
        Name: "IsNullOrEmpty",
        Description: "Returns true if the value is null or an empty string, otherwise returns false.",
        Syntax: "IsNullOrEmpty(value)",
        Keywords: ['String', 'Text', 'Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(value) {
        if (value == undefined) {
            return true;
        }
        if (value == null) {
            return true;
        }
        if (typeof value == "string" && value.length == 0) {
            return true;
        }
        if (value.toString().length == 0) {
            return true;
        }

        return false;
    },
};

